import { render, staticRenderFns } from "./BarMetrics.vue?vue&type=template&id=28bcf776&"
import script from "./BarMetrics.vue?vue&type=script&lang=js&"
export * from "./BarMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports